import React, { useEffect, useState } from "react";
import "../../css/RegionWiseReport.css";
import { apiCall } from "../../services/authServieces";
import ShowSnackBar from "../../components/snackBar";
import TablePagination from "@mui/material/TablePagination";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { saveAs } from "file-saver";
import excel from '../../Assets/images/excel.png'
import search from '../../Assets/images/search.png'
import CustomDateRangePicker from "../../components/DatePickerPastDates";
import { useUIContext } from "../../context";


const ZoneWise_report_user = () => {
  const [data, setData] = useState([]);
  const [snackBar, setSnackBar] = useState({ open: false, severity: "", message: "" });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalTemplates, setTotalTemplates] = useState(0);
  
  const [selectedRegion, setSelectedRegion] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
    // const [fromdate, setFromdate] = useState(location.state?.fromdate || defaultFrom);
    // const [todate, setTodate] = useState(location.state?.todate || defaultTo);
  const [isToDateEnabled, setIsToDateEnabled] = useState(false);

  // Get current date and calculate 2 months ago
  const today = new Date();
  const todayString = today.toISOString().split("T")[0];
  const twoMonthsAgo = new Date(today);
  twoMonthsAgo.setMonth(today.getMonth() - 2);
  const twoMonthsAgoString = twoMonthsAgo.toISOString().split("T")[0];

  // Get region from URL params
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const region = urlParams.get('region');
    if (region) {
      setSelectedRegion(decodeURIComponent(region));
    }
  }, [location]);

//   const handleFromDateChange = (event) => {
//     const selectedFromDate = event.target.value;
//     setFromDate(selectedFromDate);
//     setIsToDateEnabled(!!selectedFromDate);
//   };

//   const handleToDateChange = (event) => {
//     setToDate(event.target.value);
//   };


     const { dateRanges } = useUIContext();
  
          // ✅ Context से default date
    const dates = dateRanges.mis.map(date => {
      if (!date) return undefined;
  
      const localDate = new Date(date);
      const year = localDate.getFullYear();
      const month = String(localDate.getMonth() + 1).padStart(2, "0");
      const day = String(localDate.getDate()).padStart(2, "0");
  
      return `${year}-${month}-${day}`;
    });
  
    const [defaultFrom, defaultTo] = dates;


    const [fromdate, setFromdate] = useState(location.state?.fromdate || defaultFrom);
const [todate, setTodate] = useState(location.state?.todate || defaultTo);

  // Search with date filter
  const Getdatetodata = async () => {
    if (!fromdate) {
      setSnackBar({
        open: true,
        severity: "warning",
        message: "Please select from date first"
      });
      return;
    }

    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/reports/Search_zone_data_user?page=${page + 1}&limit=${rowsPerPage}`,
        method: "post",
        payload: { 
          fromdate, 
          todate,
          region: selectedRegion 
        }
      });

      if (res?.success) {
        setData(res.data || []);
        setTotalTemplates(res.pagination?.total || res.data.length || 0);
      }
    } catch (error) {
      setSnackBar({
        open: true,
        severity: "error",
        message: error?.response?.data?.message || "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  };


useEffect(() => {
 
  if (fromdate && todate && selectedRegion ) {

     console.log(fromdate,todate,selectedRegion,"dasfasdfasdf"
  )
    Getdatetodata();
  }
}, [fromdate, todate, selectedRegion, ]);


  // Fetch zones data for selected region
  const getZonesData = async () => {
    if (!selectedRegion) return;
    
    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/reports/get_zones_by_region?page=${page + 1}&limit=${rowsPerPage}&region=${selectedRegion}`,
        method: "GET",
      });

      if (res?.success) {
        setData(res.data || []);
        setTotalTemplates(res.pagination?.total || res.data.length || 0);
      }
    } catch (error) {
      setSnackBar({
        open: true,
        severity: "error",
        message: error?.response?.data?.message || "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedRegion &&!(fromdate && todate )) {
      getZonesData();
    }
  }, [page, rowsPerPage, selectedRegion]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Navigate to area wise report
  const handleNavigateToAreas = (zone) => {
    navigate(`/admin/area-wise-report?region=${encodeURIComponent(selectedRegion)}&zone=${encodeURIComponent(zone)}`, {
      state: {
        fromdate: fromdate,
        todate: todate,
        region: selectedRegion,
        zone: zone
      }
    });
  };

  // Calculate totals for all zones
  const calculateTotals = () => {
    return data.reduce(
      (totals, zone) => ({
        totalSend: totals.totalSend + (zone.total_send || 0),
        totalDelivered: totals.totalDelivered + (zone.total_delivered || 0),
        totalFailed: totals.totalFailed + (zone.total_failed || 0),
        totalSeen: totals.totalSeen + (zone.total_seen || 0),
      }),
      {
        totalSend: 0,
        totalDelivered: 0,
        totalFailed: 0,
        totalSeen: 0,
      }
    );
  };

  const totals = calculateTotals();

  // Export data to CSV
  const exportToCSV = () => {
    const header = [
      "Zone",
      "Total Send",
      "Total Delivered", 
      "Total Failed",
      "Total Seen",
      "Sub Total"
    ];

    const rows = data.map(zone => {
      const subTotal =
        (zone.total_send || 0) +
        (zone.total_delivered || 0) +
        (zone.total_failed || 0) +
        (zone.total_seen || 0);

      return [
        zone.zone || "Unknown",
        zone.total_send || 0,
        zone.total_delivered || 0,
        zone.total_failed || 0,
        zone.total_seen || 0,
        subTotal,
      ];
    });

    // Add totals row
    rows.push([
      "Total",
      totals.totalSend,
      totals.totalDelivered,
      totals.totalFailed,
      totals.totalSeen,
      totals.totalSend + totals.totalDelivered + totals.totalFailed + totals.totalSeen,
    ]);

    const csvContent = [
      header.join(","),
      ...rows.map(row => row.join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `zone_report_${selectedRegion}.csv`);
  };



    const handleGoBack = () => {
    navigate(`/admin/region-wise-report`, {
      state: {
        fromdate: fromdate,
        todate: todate
        
      }
    });
  };

  return (
    <>
      <div className="Template_id_contian1">
        <h4 className="Head_titleTemplate">
         <div className="DateRangeContain flex items-center">
    <CustomDateRangePicker rangeKey="mis" />
    <button
      type="button"
      className="SearchDateRange px-4 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition"
      onClick={Getdatetodata}
    >
      <img src={search} alt="Search" className="w-5 h-5" />
    </button>
  </div>


  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <button 
              onClick={handleGoBack}
              className="btn btn-secondary btn-sm"
              style={{ marginRight: '10px' }}
            >
              ← Back to Region
            </button>
             Zone Report - {selectedRegion}
          </div>



         
          <div onClick={exportToCSV} className="excel_img_btn">
            <img src={excel} alt="export" />
          </div>
        </h4>

        {loading && <div className="loading-spinner">Loading...</div>}

        <div className="Template_id_Card1">
          <div className="table_contain" id="tableContain">
            <table className="Table w-100" id="Table">
              <thead>
                <tr>
                  <th>Zone</th>
                  <th>Total Send</th>
                  <th>Total Delivered</th>
                  <th>Total Failed</th>
                  <th>Total Seen</th>
                  {/* <th>Sub Total</th> */}
                </tr>
              </thead>
              <tbody>
                {data.map((zone, index) => {
                  const subTotal =
                    (zone.total_send || 0) +
                    (zone.total_delivered || 0) +
                    (zone.total_failed || 0) +
                    (zone.total_seen || 0);

                  return (
                    <tr key={index}>
                      <td>
                        <button
                          className="btn btn-link btn-link1"
                          onClick={() => handleNavigateToAreas(zone.zone || "Unknown")}
                          style={{ textDecoration: 'none', color: '#007bff', cursor: 'pointer' }}
                        >
                          {zone.zone || "Unknown"}
                        </button>
                      </td>
                      <td>{zone.total_send || 0}</td>
                      <td>{zone.total_delivered || 0}</td>
                      <td>{zone.total_failed || 0}</td>
                      <td>{zone.total_seen || 0}</td>
                      {/* <td>{subTotal}</td> */}
                    </tr>
                  );
                })}

                {/* Totals Row */}
                <tr className="font-weight-bold">
                  <td><b>Total</b></td>
                  <td><b>{totals.totalSend}</b></td>
                  <td><b>{totals.totalDelivered}</b></td>
                  <td><b>{totals.totalFailed}</b></td>
                  <td><b>{totals.totalSeen}</b></td>
                  {/* <td>
                    <b>
                      {totals.totalSend + 
                       totals.totalDelivered + 
                       totals.totalFailed + 
                       totals.totalSeen}
                    </b>
                  </td> */}
                </tr>
              </tbody>
            </table>

            <TablePagination
              component="div"
              count={totalTemplates}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </div>
        </div>
      </div>
      
      <ShowSnackBar 
        open={snackBar.open} 
        severity={snackBar.severity} 
        message={snackBar.message} 
      />
    </>
  );
};

export default ZoneWise_report_user;